export const ROOT_FOLDER_NAME = "$$ROOT$$";
export const TRASH_FOLDER_NAME = "$$TRASH$$";
